/* @flow */
import ChatMember from 'entities/ChatMember';
import Collection from 'lib/Collection';
import User from 'entities/User';
import Subscriber from 'entities/Subscriber';

class ChatMembers extends Collection {
  initialize() {
    this.model = ChatMember;
  }

  static buildChatMember(user): ChatMember {
    if (!(user instanceof User || user instanceof Subscriber)) {
      console.warn('ChatMembers#buildChatMember only accepts User and Subscriber.');
    }

    return new ChatMember({
      id: user.id,
      name: user.getSignature() || user.getName(),
      role: user.getRole(),
      office_hours: user.getOfficeHours(),
      color: user.getColor(),
      initials: user.getInitials(),
    });
  }
}

export default ChatMembers;



// WEBPACK FOOTER //
// ./src/collections/ChatMembers.js